module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title"
  }, [_c('a', [_vm._v("Meeting the monster.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It "), _c('a', {
    attrs: {
      "id": "p16"
    }
  }), _c('a', {
    attrs: {
      "id": "p17"
    }
  }, [_vm._v("happened to be St. Valentine’s Day, and most of the women in my dormitory were getting ready for a ball at Harvard. The housemistress came knocking on doors, totally flustered, asking whether anyone was free—her brother was in Boston on business, and he needed a companion. He’d accepted an invitation to dinner and the opera with two associates and their wives, and didn’t want to be a fifth wheel, odd man out; whatever it was we said in those days. I was the only one who had no plans for the evening, so there was no room for discussion: I was “it.”")])]), _c('a', {
    attrs: {
      "id": "p17"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p17"
    }
  }, [_vm._v("I ")]), _c('a', {
    attrs: {
      "id": "p18"
    }
  }, [_vm._v("didn’t much like the housemistress, a prissy stern woman; nor was I in any mood to be sociable, cross with my flux just starting—but I agreed sweetly, privately promising myself that I would give her brother an engagement he would not soon forget.")])]), _c('a', {
    attrs: {
      "id": "p18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The evening began impressively. When I came down I found not the usual hired cab, but a well-appointed Brewster coach, complete with footman. (That would be like a liveried driver in a Cadillac today.) It was even warm inside, with a brazier.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a swift and comfortable ride into the city, but I held on to my resolve to make this Mr. Tolliver pay dearly for taking me away from my studies. Warned by the ostentatious coach that he would be wealthy and not modest, I was not surprised when we pulled up at the Parker House.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A servant led me to a lounge where the great man was waiting with his guests. I was not immediately impressed. Edward Tolliver was a tall, powerful-looking man, coarse-featured and loud. He was cordial but stiff with me and the other women; hearty with the men.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At dinner I was only as ladylike as I had to be, offering opinions more freely than I normally would do, but he actually seemed to like that, and was amused by my unladylike appetite. I was starving, hours past my normal suppertime, and had a large Porterhouse steak and plenty of claret with it—actually one of the most enjoyable meals I’d ever been served. And one of the best I would ever have, as a human.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p18"
    }
  }, [_vm._v("He ")]), _c('a', {
    attrs: {
      "id": "p19"
    }
  }, [_vm._v("was nine years older than me, too young to have fought in the war. He had a law degree from Harvard but practiced in Philadelphia, so we did have that in common, as well as Southern origins, which surprised both of us. Neither of us retained much of the South in our speech, at least around Northerners; he sounded as Bostonian as any of the others.")])]), _c('a', {
    attrs: {
      "id": "p19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I was afraid that the heavy meal and wine might put me to sleep at the theater, especially if we rode there in the warm coach, so I asked whether we might walk, and meet the others there. He readily agreed; it was only a few blocks down Tremont. The night was brisk and he was much more at ease, witty and almost charming, away from the others.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I should not have worried about sleeping through the opera, which was "), _c('em', [_vm._v("Carmen,")]), _vm._v(" new that year to these shores and most exciting. Afterwards, we went back to the Parker House and had coffee and cakes, and I returned to Wellesley scandalously late, after one in the morning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Edward wrote me weekly from Philadelphia, letters that were friendly rather than romantic, but soon it was obvious what his intentions were. I was afraid that the woman he was attracted to was not actually me, but rather the consciously forward “modern” girl I had masqueraded as, and eventually I got up the courage to write him to that effect. He responded by returning to Boston, ostensibly to meet whoever the actual “me” was.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p19"
    }
  }, [_vm._v("This ")]), _c('a', {
    attrs: {
      "id": "p20"
    }
  }, [_vm._v("was the Easter break of my senior year. We saw each other daily for more than a week. Savory lunches at the Parker House and other ostentatious places.")])]), _c('a', {
    attrs: {
      "id": "p20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In the evenings we had to be chaperoned by his sister, my housemistress, which was annoying. I felt capable of protecting my own virtue, and besides had had more than enough of her company.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I might have been grateful for her interference, had I known him as well as I came to. On the other hand, if he had shown his true colors during that courtship, I never would have married him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sometimes I consider that: what if I had married a nice man instead, and settled down to a regular life in Boston or Philadelphia, or wherever. The worlds I would have missed. This world would have been far different, too.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p20"
    }
  }, [_vm._v("If ")]), _c('a', {
    attrs: {
      "id": "p21"
    }
  }, [_vm._v("Gordon had never been born, this world could be a lifeless radioactive ball.")])]), _c('a', {
    attrs: {
      "id": "p21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("But I didn’t have a "), _c('em', [_vm._v("crystal")]), _vm._v(" ball. I was swept away by his attentions and charmed by his clumsy gallantry—he was much more attractive to me than a more polished, polite man would have been, with his obvious struggle to do and say the right things, keeping in check an elemental force that intrigued me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was too naive to see that force for what it was: raw sexual desire, and the need to dominate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was an unusually clement spring—I remember a blizzard on Easter morning, another year—and we ranged all around the area in a nimble calash that he hired and drove himself. Downtown Boston was a noisome cesspool in the thaw, as always, so most of our travels were out in the country, going as far as Salem on occasion. We picnicked and chatted; I learned a lot about the masculine worlds of finance and law, and he paid polite attention to my ramblings about nature and art and literature.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After ten days, he proposed to me, with a diamond ring that I supposed was worth more than I owned. He wanted me to come back to Philadelphia with him, right then!—and was not amused when "), _c('em', [_vm._v("I")]), _vm._v(" was amused, saying that I was not about to go to college for three and a half years, only to leave with no degree. He argued with some force that I would never need the degree; I would never need to work. He had come into a fortune at twenty-one, and it had grown constantly since.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p21"
    }
  }, [_vm._v("What ")]), _c('a', {
    attrs: {
      "id": "p22"
    }
  }, [_vm._v("is clear now is that he wanted to cut short my education so as to limit my potential for independence. If I could work, I could leave him, though of course in 1879 that would never have entered my mind. Divorce was an exotic thing that degenerate foreigners did, or free-thinking atheists.")])]), _c('a', {
    attrs: {
      "id": "p22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He did grudgingly wait. We were married right after my graduation, in the largest Episcopalian church in Philadelphia. There were hundreds in attendance, though not a dozen on my side of the aisle. Most of them were “codfish aristocracy,” people who had actually made money rather than being born into it. (Edward was not Episcopalian, or anything else. The church was chosen for status and size.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were so many flowers that I nearly choked on their cloying ambience. I managed not to sneeze until we were outside the church.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "p22"
    }
  }, [_vm._v("In retrospect I suppose it was vulgar and dishonest, if honesty mandated mutual love and respect before holy matrimony. I did love Edward in a naive, schoolgirl way, and Edward had reached an age and ")]), _c('a', {
    attrs: {
      "id": "p23"
    }
  }, [_vm._v("station where not having a wife and family was considered peculiar. He set out to find an upper-class woman who was both beautiful and educated. That my “aristocratic” family was a thousand miles away and destitute was a real advantage to a man who wanted absolute control over his life, and especially over his wife.")])]), _c('a', {
    attrs: {
      "id": "p23"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a24f5b4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter002.vue
// module id = 81
// module chunks = 0